import {
  PostTicketServiceRequestContactsResponse,
  ServiceRequestContactSelectionDto,
  TicketAdditionalContactDTO,
  TicketClient,
} from "lib/ShiOneClient";
import { ApiClientConfig } from "../auth/ApiClientConfig";
const api = new TicketClient(
  ApiClientConfig,
  import.meta.env.API_ENDPOINT
);
export async function getRestSecondaryTicketContactsById(
  ticketNumber: number
): Promise<TicketAdditionalContactDTO[]> {
  return api.getTicketAdditionalContactsByTicket(ticketNumber);
}

export async function postRestSecondaryTicketsByContactIdAndTicketNumber(
  ticketNumber: number,
  selections: ServiceRequestContactSelectionDto[]
): Promise<PostTicketServiceRequestContactsResponse> {
  return api.postTicketAdditionalContacts(ticketNumber, selections);
}
